import { useIntl } from 'react-intl';

import styles from './PeriodPills.module.less';

interface Props {
  value: number;
  options: number[];
  onChange: (next: number) => void;
}

export function PeriodPills({ value, options, onChange }: Props) {
  const intl = useIntl();
  return (
    <div className={styles.row}>
      <label className={styles.label}>
        {intl.formatMessage({
          id: 'calculator.loanPeriod',
          defaultMessage: 'Loan period (months)',
        })}
      </label>
      <div className={styles.pills} role="radiogroup" aria-label="Loan period">
        {options.map(opt => {
          const active = opt === value;
          return (
            <button
              type="button"
              key={opt}
              role="radio"
              aria-checked={active}
              className={`${styles.pill} ${active ? styles.pillActive : ''}`}
              onClick={() => onChange(opt)}
            >
              {intl.formatMessage({
                id: 'calculator.months',
                defaultMessage: 'Loan period (months)',
              }, { months: opt })}
            </button>
          );
        })}
      </div>
    </div>
  );
}
